import { useMemo } from "react";
import { statuses } from "@sia/style-guide";

const buildStructure = (translate, isOverheadsComplete, isEmployeesSubmitted) => ({
  columns: 2,
  columns_tablet: 2,
  columns_mobile: 2,
  page_section_element: [
    {
      segment: "companyOverhead",
      id: "overhead-costs",
      title: translate("benchmarking.navigation-menu.data-collection.overhead-costs"),
      status: isOverheadsComplete ? statuses.COMPLETE.id : statuses.INPROGRESS.id,
      page_section_element: {
        page: {
          title: translate("benchmarking.survey.company-overhead.title"),
        },
      },
    },
    {
      segment: "employees",
      id: "hours-worked",
      title: translate("benchmarking.navigation-menu.data-collection.employee"),
      status: isEmployeesSubmitted ? statuses.COMPLETE.id : statuses.INPROGRESS.id,
      page_section_element: {
        page: {
          title: translate("benchmarking.survey.employee.title"),
        },
      },
    },
  ],
});

export function useSurveySectionStructure(translate, isOverheadsComplete = false, isEmployeesComplete = false) {
  return useMemo(() => buildStructure(translate, isOverheadsComplete, isEmployeesComplete), [isEmployeesComplete, isOverheadsComplete, translate]);
}
